<div class="raptor-total-price-container">

  <div class="flex flex-column align-center" *ngIf="componentDetails.component === 'active_price'">

    <div class="raptor-total-price-panel" #container>
      <div *ngIf="banners">
        <div *ngFor="let banner of banners">
          <div *ngIf="banner.tag" class="margin-vertical-xsmall raptor-total-price-banner">
            {{ getTagLabel(banner) }}
          </div>
        </div>
      </div>

      <label class="raptor-total-price-heading-label margin-bottom-xsmall inline-block hide-for-tiny-only" *ngIf="heading" [innerHTML]="heading">
      </label>

      <!-- Arrangement fee title banner -->
      <div class="h4-subheading margin-bottom-none" *ngIf="!raptorStepService.updating && price.frequency === 'month' && additionalCharges.enabled && additionalCharges.banner">
        {{ additionalCharges.banner.monthlyHeading }}
      </div>

      <div class="total-price-detail-container">
        <open-price *ngIf="!raptorStepService.updating" [price]="price" [precision]="precision"></open-price>
        <div *ngIf="raptorStepService.updating">
          <mat-spinner diameter="50" class="price-spinner"></mat-spinner>
        </div>
      </div>

      <!-- Arrangement fee tag banner -->
      <div class="raptor-total-price-upfront-extras-banner margin-bottom-xsmall text-xsmall" 
        *ngIf="!raptorStepService.updating && additionalCharges.enabled && additionalCharges.banner" 
        [innerHTML]="price.frequency === 'month' ? additionalCharges.banner.tag.monthly : additionalCharges.banner.tag.annual">
      </div>

      <div class="strong-small" [ngClass]="{ 'margin-bottom-xsmall': !additionalCharges.enabled }" *ngIf="subText && !raptorStepService.updating" [innerHTML]="subText"></div>
    </div>

    <div class="raptor-sidebar-section-group-container" *ngIf="!raptorStepService.updating && price.frequency === 'month' && additionalCharges.showBreakdown && additionalCharges.breakdown">
      <div class="raptor-sidebar-section-group-panel">
        <div class="flex text-left breakdown-last padding-top-small margin-top-xsmall">
          <label class="label-small">Total monthly amount</label>
        </div>
        <div class="flex text-left">
          <label class="label-small label-change flex-grow">First month</label>
          <span class="text-small text-right flex-grow">
            <open-price [price]="additionalCharges.breakdown.firstMonthlyPayment" [precision]="precision" size="xsmall"></open-price>
          </span>
        </div>
        <div class="flex text-left">
          <label class="label-small label-change flex-grow">11 remaining months</label>
          <span class="text-small text-right flex-grow">
            <open-price [price]="additionalCharges.breakdown.subsequentPayment" [precision]="precision" size="xsmall"></open-price>
          </span>
        </div>
      </div>
    </div>

    <div *ngIf="priceDetails && !raptorStepService.updating" class="raptor-sidebar-section-group-container">
      <div class="raptor-sidebar-section-group-panel">
        <ng-container *ngFor="let item of priceDetails; let last = last">
          <div *ngIf="item.group_start" class="flex text-left" [ngClass]="{ 'breakdown-last padding-top-small margin-top-xsmall': item.group_start,  'padding-vertical-small': item.group_start && last}">
            <label class="label-small label-change">{{ item.title }}</label>
          </div>
          <div class="flex text-left">
            <label class="label-small label-change flex-grow">{{ item.label }}</label>
            <span class="text-small text-right flex-grow">
              <open-price [price]="item" [precision]="precision" size="xsmall"></open-price>
            </span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>


  <div class="flex flex-column align-center" *ngIf="componentDetails.component === 'change_en_ca_price_component' || componentDetails.component === 'new_rn_price'">
    <!-- Current and New Price -->
    <div *ngIf="!raptorStepService.updating">
      <ng-container *ngIf="componentDetails.component === 'change_en_ca_price_component'">
        <label class="margin-bottom-none inline-block hide-for-tiny-only">Payable</label>
        <div class="flex">
          <div class="flex flex-grow flex-justify-start">
            <div class="flex-shrink">
              <label class="label-small label-change">Current</label>
              <open-price [price]="priceCurrent" [precision]="0" size="small"></open-price>
            </div>
          </div>
          <div class="flex flex-grow flex-justify-end">
            <div class="flex-shrink">
              <label class="label-small label-change">New</label>
              <open-price [price]="priceNew" [precision]="0" size="small"></open-price>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Price difference -->
      <div [class]="{ 'padding-top-small': componentDetails.component === 'change_en_ca_price_component' }">
        <label *ngIf="componentDetails.heading" class="margin-bottom-xsmall inline-block hide-for-tiny-only width-full" [innerHTML]="heading"></label>
        <!-- PAF first month payable for endorsement before first payment/renewal -->
        <label *ngIf="firstMonthPriceHeading" class="margin-bottom-none" [innerHTML]="firstMonthPriceHeading"></label>
        <div>
          <open-price [price]="priceDelta" [precision]="precision"></open-price>
        </div>
      </div>
    </div>

    <div *ngIf="raptorStepService.updating">
      <svg *ngIf="raptorStepService.updating" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
        <path d="M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50" fill="#0f214d" stroke="none">
          <animateTransform attributeName="transform" type="rotate" dur="1s" repeatCount="indefinite" keyTimes="0;1" values="0 50 51;360 50 51"></animateTransform>
        </path>
      </svg>
    </div>

    <span class="strong-small" *ngIf="subText && !raptorStepService.updating" [innerHTML]="subText"></span>
  </div>
</div>
